import * as React from "react";
const SvgFiRrPepperHot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pepper-hot_svg__a)">
      <path
        fill="#062147"
        d="M3 3.172a1.01 1.01 0 1 1 2-.006 2.4 2.4 0 0 0 .707 1.713A4.45 4.45 0 0 1 7 8a1 1 0 0 1-2 0 2.43 2.43 0 0 0-.707-1.707A4.38 4.38 0 0 1 3 3.172m6 3.52A1.02 1.02 0 1 0 11 7a4.47 4.47 0 0 0-1.293-3.429A2.4 2.4 0 0 1 9 1.864V1a1 1 0 0 0-2 0v.864a4.39 4.39 0 0 0 1.293 3.122A2.4 2.4 0 0 1 9 6.692M24 11a12.48 12.48 0 0 1-12 13 11.9 11.9 0 0 1-8.4-3.437C1.038 18.525-2.665 9.481 2.65 9a2.634 2.634 0 0 1 2.568 2.064C6.123 15 7.923 15 8.515 15c2.033 0 3.465-1.626 3.485-3.953a6.07 6.07 0 0 1 4.955-5.941C16.687 2.351 15.171 2 14 2a1 1 0 1 1 0-2c1.752 0 4.618.687 4.965 5.085A6.02 6.02 0 0 1 24 11m-8.367-3.2a2.956 2.956 0 0 0 4.733 0 3.926 3.926 0 0 0-4.733 0M22 11a4 4 0 0 0-.348-1.622 4.964 4.964 0 0 1-7.28.028A4.2 4.2 0 0 0 14 11.064C13.972 14.448 11.614 17 8.515 17c-1.818 0-4.2-.952-5.246-5.488a.639.639 0 0 0-1.26.11C2.25 25.7 22.185 25.261 22 11M12 24c-.076 0 .075 0 0 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pepper-hot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPepperHot;
